module.exports = __webpack_public_path__ + "static/media/video_2.14d91698.mp4";